/* eslint-disable no-undef */

const TAG = 'GA';

const GoogleAnalytics = {
  pageView(route) {
    try {
      ga('send', 'pageview', route);
    } catch (error) {
      console.log(TAG, 'pageview', error);
    }
  },

  orderSend(price, currency, externalOrderId, shipping, items) {
    try {
      ga('require', 'ecommerce');
      ga('ecommerce:addTransaction', {
        id: externalOrderId,
        revenue: price,
        shipping, // Shipping.
        tax: 0, // TODO Tax. 0?
        currency, // local currency code.
      });
      items.forEach(item =>
        ga('ecommerce:addItem', {
          id: externalOrderId, // Transaction ID.
          name: item.id, // Product name.
          sku: item.id, // TODO SKU/code. ID?
          category: item.id, // Category or variation. Hm?
          price: item.single, // Unit price.
          quantity: item.quantity, // Quantity.
          currency, // local currency code.
        }),
      );
      ga('ecommerce:send');
    } catch (error) {
      console.log(TAG, 'orderSend', error);
    }
  },
};

export default GoogleAnalytics;
